require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-colombia-and-the-world-banks-territorial-development.json") })
        }
      }, "path---en-us-update-colombia-and-the-world-banks-territorial-development");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-colombia-and-the-world-banks-territorial-development!./.cache/json/en-us-update-colombia-and-the-world-banks-territorial-development.json
// module id = 644
// module chunks = 231608221292675